const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectroScooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -952.36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.274 -4.402)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -10.536,
    cy: 1032.896,
    r: 6.009,
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10.451,
    cy: 1032.959,
    r: 1.964,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.408 -4.191)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -10.536,
    cy: 1032.896,
    r: 6.009,
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10.451,
    cy: 1032.959,
    r: 1.964,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.97507 .22188 -.18303 .80436 199.78 191.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.475 1011.21h.514v21.362h-.514z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.02216649,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.754,
    cy: 1010.415,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.688,
    cy: 1034.717,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.64301 .12205 -.273 1.43827 300.53 -481.355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.475 1011.21h.514v21.362h-.514z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.02216649,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.754,
    cy: 1010.415,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.688,
    cy: 1034.717,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.00732 -.51328 .25763 .00993 -235.317 964.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.475 1011.21h.514v21.362h-.514z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.02216649,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.754,
    cy: 1010.415,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.688,
    cy: 1034.717,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24.216,
    cy: 969.555,
    r: 0.543,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.37781191,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.86451 -.59524 .3477 .38484 -336.892 632.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.475 1011.21h.514v21.362h-.514z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.02216649,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.754,
    cy: 1010.415,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.688,
    cy: 1034.717,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 .6545 -1.3676 0 1447.25 1020.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.475 1011.21h.514v21.362h-.514z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.02216649,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.754,
    cy: 1010.415,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.688,
    cy: 1034.717,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.015 1028.417h35.883v.74H32.015z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.4220233,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 .6545 -.36216 0 441.854 1022.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.475 1011.21h.514v21.362h-.514z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.02216649,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.754,
    cy: 1010.415,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.688,
    cy: 1034.717,
    rx: 0.423,
    ry: 1.615,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.76618981,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.983 1025.385c5.982-6.34 8.926-5.602 12.338-4.512 2.047.654 3.208 1.914 3.977 3.505.516 1.067 1.43 2.855 1.43 2.855.766 0 .114-1.564-.119-2.292-.373-1.165-1.097-2.238-1.97-3.093-.875-.855-1.992-1.472-3.136-1.901-1.08-.405-2.255-.565-3.407-.594-1.053-.027-2.155 0-3.138.381-1.961.759-3.98 2.447-5.144 3.652-.872.903-3.565 2.38-3.565 2.38z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.47,
    cy: 1025.803,
    rx: 0.535,
    ry: 0.602,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.43910921,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-421.351 937.095h.241v1.603h-.241z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.84490144,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-29.032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.988 1030.26-1.877-3.25",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.40000001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.43,
    height: 2.879,
    x: -597.511,
    y: 671.23,
    ry: 0.416,
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.60463119,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.5983 -.80127 .57654 .81707 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.627 1030.277.88-5.901",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.05484664px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectroScooter);
export default __webpack_public_path__ + "static/media/electro-scooter.82cf35879034d26fd07e82c0e94ad218.svg";
export { ForwardRef as ReactComponent };